<template>
  <el-pagination
    ref="pagination"
    :current-page="value.pageNo"
    :layout="layout"
    :page-size="value.pageSize"
    style="padding-top:30px"
    v-bind="$attrs"
    v-on="$listeners"
    @size-change="sizeChange"
    @current-change="currentChange"
  />
</template>

<script>
export default {
  name: 'base-pagination',
  props: {
    value: {
      type: [Object],
      default: function() {
        return {
          pageNo: 1,
          pageSize: 15
        };
      }
    }
  },
  computed: {
    layout() {
      const base = ['total', 'prev', 'pager', 'next', 'jumper'];
      if (this.$attrs['page-sizes']) {
        base.splice(1, 0, 'sizes');
      }
      return base.join(',');
    }
  },
  methods: {
    currentChange(e) {
      this.$nextTick(() => {
        this.$emit('input', Object.assign({}, this.value, { pageNo: e }));
      });
    },
    sizeChange(e) {
      this.$nextTick(() => {
        this.$emit('input', Object.assign({}, this.value, { pageSize: e }));
      });
    }
  }
};
</script>
